import router from "src/routes/routes";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);
const base = "/api/auditLogs";

export const auditLogsService = {
  list: (params) => api.getCall(base, params),
  getById: (id) => api.getCall(`${base}/${id}`),
  getResourceTypes: () => api.getCall(`${base}/resource-types`),
  getActionTypes: () => api.getCall(`${base}/action-types`),
  getResourceHistory: (resource, resourceId) =>
    api.getCall(`${base}/resource/${resource}/${resourceId}`),
};
